import { render } from "./vNav_mobile.vue?vue&type=template&id=2a3da452&scoped=true"
import script from "./vNav_mobile.vue?vue&type=script&lang=js"
export * from "./vNav_mobile.vue?vue&type=script&lang=js"

import "./vNav_mobile.vue?vue&type=style&index=0&id=2a3da452&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a3da452"]])

export default __exports__